import styled from 'styled-components';
import useTranslate from '../../../../hooks/useTranslate';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@digitools/honest-react';
import useTealium from 'src/hooks/useTealium';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
const TEXT_NOTIFICATIONS_LINK_TEXT = {
    english: 'Get text notifications',
    spanish: 'Recibir notificaciones por mensaje de texto',
};
const StyledLink = styled(Link) `
  padding: .5rem 2rem;
  color: ${({ theme }) => theme.palette.secondaryDark};
  background-color: rgb(255, 255, 255);
  border: 1px solid ${({ theme }) => theme.palette.secondaryDark};
`;
const LinkIcon = styled(Icon) `
  padding-right: .25rem;
  vertical-align: middle;
`;
const IconWrapper = styled.span `
  display: inline-block;
  text-decoration: none !important;
`;
const CommunicationPreferencesLink = () => {
    const { t } = useTranslate();
    const { trackEvent } = useTealium();
    const trackEventLinkClicked = () => {
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
            event_name: TEXT_NOTIFICATIONS_LINK_TEXT.english,
            event_type: TEALIUM_EVENT.EVENT_TYPE.VIEW_STATUS,
        });
    };
    return (<StyledLink onClick={trackEventLinkClicked} className='button' to="/profile/alertsNotifications">
      <IconWrapper>
        <LinkIcon name='text-notification' color='secondaryDark'/>
      </IconWrapper>
      {t(TEXT_NOTIFICATIONS_LINK_TEXT)}
    </StyledLink>);
};
export default CommunicationPreferencesLink;
